import { usePackageProductItem } from '@jetshop/core/hooks/PackageProducts';
import Image from '@jetshop/ui/Image';
import { Price } from '@jetshop/ui/Price';
import ProductLink from '@jetshop/ui/ProductLink';
import React, { useEffect } from 'react';
import { styled } from 'linaria/react';
import StockStatusIndicator from '../StockStatus/StockStatusIndicator';
import { VariantSelector } from '../VariantSelector';

const PackageProductItemWrapper = styled('div')`
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 12px;
  padding-bottom: 12px;
  color: black;
  display: grid;
  grid-template-columns: 72px auto;
  grid-gap: 12px;
`;

const PriceStockStatusWrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: 16px;
`;

const ProductName = styled(ProductLink)`
  font-weight: 600;
  font-size: 18px;
  text-decoration: none;
  color: black;
  :hover {
    text-decoration: underline;
  }
`;

const ImageWrapper = styled(ProductLink)`
  width: 72px;
  img {
    :hover {
      opacity: 0.8 !important;
    }
  }
`;

const PackageProductInfoWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
const ProductDescription = styled('p')`
  margin-top: 6px;
`;

const StyledStockStatusIndicator = styled(StockStatusIndicator)`
  margin-top: 0px;
`;

const PackageProductPriceWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  align-self: flex-end;
  margin-left: auto;
  .package-product-price {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    margin-top: 0.5rem;
    .price,
    .new-price,
    .old-price {
      font-size: 18px;
      display: inline-block;
      margin-right: 0px;
      margin-left: 8px;
    }
    .price,
    .new-price {
      font-size: 18px;
    }
    .old-price {
      color: black;
    }
  }
`;

export function PackageProductItem({
  item,
  updatePackageItem,
  price,
  index,
  setPrevPriceAtIndex,
}) {
  const { stockStatus, variantHandler } = usePackageProductItem(
    item,
    updatePackageItem
  );

  const product = item.product;

  // USE THE HIGHEST POSSIBLE PRICE AS PREVIOUS PRICE
  const newPrice = {
    price: price.price,
    previousPrice:
      variantHandler?.selectedVariant?.previousPrice ||
      product.previousPrice ||
      price.previousPrice ||
      null,
  };

  const { selectedVariant: selectedVariation } = variantHandler;

  // Flytta state-uppdateringen in i en useEffect
  useEffect(() => {
    setPrevPriceAtIndex(index, newPrice.previousPrice, item.minQuantity);
  }, [index, newPrice.previousPrice, item.minQuantity, setPrevPriceAtIndex]);

  return (
    <PackageProductItemWrapper>
      <ImageWrapper product={product}>
        <Image
          sizes={[1 / 10]}
          aspect={'1:1'}
          alt={product?.images[0]?.alt}
          src={
            variantHandler.selectedVariant
              ? variantHandler.selectedVariant?.images[0]?.url
              : product?.images[0]?.url
          }
        />
      </ImageWrapper>
      <PackageProductInfoWrapper>
        <ProductName product={product}>
          {product.name} {item.minQuantity > 1 && ` x ${item.minQuantity}`}
        </ProductName>
        <ProductDescription>{product.subName}</ProductDescription>
        {product.hasVariants && (
          <VariantSelector
            product={product}
            variantHandler={variantHandler}
            selectedVariation={selectedVariation}
          />
        )}
        <PriceStockStatusWrapper>
          <StyledStockStatusIndicator
            status={stockStatus.status}
            text={stockStatus.text}
          />
          <PackageProductPriceWrapper>
            <Price {...newPrice} className="package-product-price" />
          </PackageProductPriceWrapper>
        </PriceStockStatusWrapper>
      </PackageProductInfoWrapper>
    </PackageProductItemWrapper>
  );
}
